import config from '@/Constants';
import {
  QueryCardDataParams,
  QueryCardDataResponse,
} from '@queryfilter/domain/interfaces';
import AxiosHelper from '@shared/infra/protocols/http/AxiosHelper';
import { CancelToken } from 'axios';

async function fetchCardData(
  path: string,
  params: QueryCardDataParams,
  cancelToken: CancelToken,
): Promise<Nullable<QueryCardDataResponse>> {
  try {
    const urlAux = config.DASHBOARD_MOCK ? config.DASHBOARD_MOCK_URL : '';

    let url = `${urlAux}${path}`;

    if (params.filters) url += params.filters;

    if (params.search && params.page) {
      url += `&${params.search}&page=${params.page}`;
    } else {
      if (params.search) url += `&${params.search}`;
      if (params.page) url += `&page=${params.page}`;
    }

    const response = await AxiosHelper.get({ url, cancelToken });
    const data: QueryCardDataResponse = response.body;
    return data;
  } catch (error) {
    return null;
  }
}

export default fetchCardData;
